var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFF3EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0101 12.916H14.3434C13.4229 12.916 12.6768 13.6622 12.6768 14.5827V26.2493C12.6768 27.1698 13.4229 27.916 14.3434 27.916H26.0101C26.9306 27.916 27.6768 27.1698 27.6768 26.2493V14.5827C27.6768 13.6622 26.9306 12.916 26.0101 12.916Z",
    stroke: "#2F3567",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5098 16.25H16.0098V23.75H18.5098V16.25Z",
    stroke: "#FF6F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3438 16.25H21.8438V20.4167H24.3438V16.25Z",
    stroke: "#FF6F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.70319f277e9ee82ea3273fc08c5de4f0.svg";
export { ForwardRef as ReactComponent };